import { captureException } from '@canvas/sentry-react';

import { type IdentifiedError } from './types';

export function sendErrorDetailsToSentry(
  { error, type, isRecoverable }: IdentifiedError,
  captureLocation: string
) {
  const level = isRecoverable ? 'error' : 'fatal';
  const sentryErrorId = captureException(error, {
    level,
    tags: {
      errorType: type,
      isRecoverableError: isRecoverable,
      captureLocation,
    },
  });
  return sentryErrorId;
}
